import actions from './actions'

const initialState = {
    header: '',
};

export default function headerReducer(state = initialState, action: any) {
    switch (action.type) {
        case actions.SET_STATE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}
